import { DOCUMENT } from "@angular/common";
import { AfterViewInit, Component, ElementRef, Inject, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs";
import { Modal } from 'flowbite';
import { FormsModule } from '@angular/forms';
import { I18nServices } from "../../i18n/i18n.service";
import { OrderService } from "../../order/order.service";
import { Order } from "../../domain/order";
import { RecaptchaService } from "../recaptcha.service";

@Component({
    templateUrl: './recaptchapopup.component.html',
    selector: 'recaptcha-popup',
    styleUrls: [ './recaptchapopup.component.scss' ],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class RecaptchaPopupComponent implements AfterViewInit {

    @Output('onChange')
    public onChange: ReplaySubject<any> = new ReplaySubject();

    @ViewChild('recaptchaModal') protected recaptchaModal: ElementRef<HTMLElement>;
    protected modal;

    protected setupPromise: Promise<boolean>;
    protected setupResolve: (value: boolean) => void;

    // Add new property to track loading state
    protected isProcessing = false;

    public constructor(public orderService: OrderService,
                       protected i18nService: I18nServices, 
                       protected recaptchaService: RecaptchaService,
                       @Inject(DOCUMENT) private document: Document) {
        // Initialize setup promise
        this.setupPromise = new Promise<boolean>((resolve) => {
            this.setupResolve = resolve;
        });
    }

    public ngAfterViewInit() {
        this.modal = new Modal(this.recaptchaModal.nativeElement, {
            backdropClasses: 'bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0',
            onShow: () => {
                this.document.body.classList.add('on-modal');
            },
            onHide: () => {
                this.document.body.classList.remove('on-modal');
            }
        });
        
        // Resolve the setup promise
        this.setupResolve(true);
    }

    public show() {
        // Wait for the modal to be initialized before showing it
        this.setupPromise.then(() => {
            if (this.modal) {
                this.modal.show();
                this.recaptchaService.renderRecaptcha('recaptcha-container');
            }
        });
    }

    public hide() {
        if (this.modal) {
            this.modal.hide();
        }
    }
}